document.addEventListener('DOMContentLoaded', function() {
  const bisButton = document.querySelector('.overtone-bis-button');
  const productBtn = document.querySelector('.product__submit__item [data-add-to-cart]');
  
  if (!bisButton) return;
  const observer = new MutationObserver(() => {
    if (window.getComputedStyle(bisButton).display === 'inline') {
      bisButton.style.display = 'block';
    }
    console.log("Is product btn disabled? " , productBtn.disabled)
    
    const variant = getSelectedVariant();
    
    if(variant.sku === 'ES101'){
      productBtn.style.display = 'block';
    }else{
      if(productBtn.disabled){
        bisButton.style.display = 'block';
        productBtn.style.display = 'none';
      }else{
        // productBtn.style.display = 'block';
        bisButton.style.display = 'none';
      }
    }
  });
  
  observer.observe(bisButton, { attributes: true, attributeFilter: ['style', 'class'] });
  
});
function getSelectedVariant() {
  const selectedVariant = document.querySelector('[data-variant-buttons] input[type="radio"]:checked');
  const button = document.querySelector('.product__submit__item [data-add-to-cart]');

  if (!selectedVariant || !button) return;
  
  const variantId = selectedVariant.value;
  
  let currentVariant = null;
  if (window.productData && window.productData.variants) {
    currentVariant = window.productData.variants.find(v => v.title == variantId);
  }
  if (!currentVariant) return;

  return currentVariant;
}